module.exports = __webpack_public_path__ + "static/server-2465d96cb2bb3a9d59ae5c4bf07ceaf3.png";